<style scoped>
.offline:after {
  position: absolute;
  content: "";
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 1.5rem;
  width: .5rem;
  height: .5rem;
  background: red;
  border-radius: 50%;
}
.online:after {
  position: absolute;
  content: "";
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 1.5rem;
  width: .5rem;
  height: .5rem;
  background: #1ab137;
  border-radius: 50%;
}
.online,.offline{
  padding: 0 1rem;
}
.device-down-container{
  display: flex;
  justify-content: space-between;

}
.device-down-container .device-list{
}
.device-down-container .device-list .device-list-item .el-checkbox{
  display: flex;
  justify-content: left;
  align-items: center;
  height: 2.2rem;
  line-height: 2.2rem;
  font-size: 1rem;
  vertical-align: middle;
}
.device-down-rule{
  width: calc(100% - 390px);
}

.device-list{
  overflow-y: auto;
  height: 360px;
  margin-top: 5px;
}
.device-sn-search{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
<style>
.device-down-container .device-list .device-list-item .el-checkbox .el-checkbox__label{
  font-size: 1rem!important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.device-down-transfer .el-transfer-panel{
  width: calc(50% - 95px);
}
</style>

<template>
	<el-dialog title="下发设备门禁规则" top="20px" class="device-binding-dialog" :visible.sync="visible" width="60%" :close-on-click-modal="false">
      <div class="device-down-container">
        <el-card style="width: 380px">
          <div class="device_down_search_left">
            <div style="justify-content: space-between;display: flex;margin: 10px 0;">
              <el-select
                  clearable
                  style="margin-right: 10px;width: 30%"
                  v-model="searchForm.online"
                  placeholder="状态"
                  @change="onSearch"
              >
                <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select clearable v-model="searchForm.type" style="width: 70%;" @change="onSearch" placeholder="设备类型">
                <el-option v-for="item in category" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="de_search_name de_search device-sn-search">
              <div style="width: 30%;margin-right: 10px;">
                <el-checkbox v-model="searchForm.checked" @change="selectAll">全选</el-checkbox>
              </div>
              <el-input v-model="searchForm.likeString" clearable placeholder="设备名称、云序列号"
                        style="width: 70%;" @keyup.enter.native="onSearch">
              <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="onSearch"></i>
            </el-input>
            </div>
          </div>
          <div class="device-list">
            <el-checkbox-group v-model="deviceList" class="device-list-item">
              <el-checkbox v-for="(item,index) in deviceData" :key="index" :label="item.id" :disabled="item.status==0">
                <span :class="item.status==0?'offline':'online'">
                  {{ item.name }} ({{ item.sn }})
                </span>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
        <div class="device-down-rule">

          <el-card>
            <div style="justify-content: space-between;display: flex;margin: 10px 0;">
              <el-input placeholder="设备门禁规则名称" style="width: 60%" v-model="searchQuery.name" clearable></el-input>
              <div><el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button></div>
            </div>
            <el-table :data="tableData" size="mini"  :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}"
                      @current-change="handleSelectCurrentChange"
                      @row-click="handleSelectCurrentChange"
                      highlight-current-row
                      height="380">
              <template slot="empty">
                <div>
                  <img src="@/assets/nodata.png" class="nodata" />
                  <div>无数据</div>
                </div>
              </template>
              <el-table-column align="center" width="55">
                <template slot-scope="scope">
                  <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                  <el-radio class="radio" v-model="fromData.ruleId" :label="scope.row.id"
                  >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column label="规则名称" prop="name" show-overflow-tooltip/>
              <el-table-column label="类型" prop="type">
                <template slot-scope="scope">
                  <div v-if="scope.row.type === 1" class="table_scope_t">按周</div>
                  <span v-else class="table_scope_f">按时段</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="status">
                <template slot-scope="scope">
                  <div v-if="scope.row.status === 1" class="table_scope_t">开启</div>
                  <span v-else class="table_scope_f">禁用</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-pagination v-model:current-page="searchQuery.pageNum"  style="margin-top: 5px;" :page-size="searchQuery.pageSize"
                           layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
          </el-card>
        </div>
      </div>



		<div slot="footer" style="text-align: right;margin-top: 20px;">
			<el-button @click="visible = false">取消</el-button>
			<el-button type="primary" :loading="subLoading" @click="submitBind">下发规则</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { NexusDeviceApi } from "@/api/nexus/device"
	import { DeviceRuleApi } from "@/api/nexus/deviceRule"
	export default {
		data() {
			return {
        searchForm:{checked:false},
        category: [{
          label: "指纹系列考勤机", //FP
          value: 0,
        },
          {
            value: 1,
            label: "近红外人脸考勤机", //NI || NP
          },
          {
            value: 2,
            label: "动态人脸考勤机", //AI||AF||AP
          },
          {
            value: 3,
            label: "近红外人脸门禁机",
          },
          {
            value: 4,
            label: "动态人脸门禁机",
          },
        ],
        statusList: [{
          value: 1,
          label: "在线",
        },
          {
            value: 0,
            label: "离线",
          },
        ],
				//设备门禁规则id
				ruleId: '',
				visible: false,
				titles: ["未选择规则", "已选择规则"],
        allDeviceList: [],
				//未设备集合
				deviceData: [],
				//已绑定设备集合
				deviceList: [],
        ruleList: [],
				subLoading: false,
        deviceRuleList: [],
        searchQuery: {
          pageNum: 1,
          pageSize: 10,
        },
        tableTotal: 0,
        tableData: [],
        fromData: {
          ruleId: null,
          deviceIds: [],
        }
			}
		},
    mounted() {

    },
    methods: {
      selectAll(val) {
        if (val) {
          this.deviceList = this.deviceData.filter(d => d.status === 1).map(d => d.id);
        } else {
          this.deviceList = [];
        }
      },
      onSearch(){
        //likeString
        const that = this;
        let list = this.allDeviceList;
        console.info('that.searchForm__',that.searchForm);
        list = list.filter(d => {
          const nameFilter = (that.searchForm.likeString === undefined || that.searchForm.likeString === null || that.searchForm.likeString === '') || (d.name.includes(that.searchForm.likeString) || d.sn.includes(that.searchForm.likeString));
          return (nameFilter);
        });
        list = list.filter(d => {
          const onlineFilter = that.searchForm.online === undefined || that.searchForm.online === null || that.searchForm.online === ''?true:d.status === that.searchForm.online;
          return onlineFilter;
        });
        list = list.filter(d => {
          const typeFilter = that.searchForm.type === undefined || that.searchForm.type === null || that.searchForm.type === ''?true:d.type === that.searchForm.type;
          return typeFilter;
        });
        this.deviceData = list;
      },
      handleNexusDeviceList(){
        let that = this;
        NexusDeviceApi.querySimpleList().then( response => {
          let {code,data} = response;
          if(200 == code){
            let list = data?.map(d => {
              d.disabled = (d.status == 0);
              return d;
            });
            that.deviceData = list
            that.allDeviceList = list;
          }
        })
      },
			//提交
			async submitBind() {

			},
			//打开页面
			show(ruleId) {
        this.deviceList = [];
        this.searchForm.checked = false;
        this.fromData = {
          ruleId: null,
          deviceIds: []
        }
        this.handleNexusDeviceList();
        this.getDeviceRegulationList();
				//延迟打开页面，不会出现数据闪现情况
        this.visible = true;
			},
      async getDeviceRegulationList() {
        console.log(this.searchQuery)
        let {data,code} = await DeviceRuleApi.deviceRegulationPage(this.searchQuery);
        if(code == 200){
          this.tableData = data.list;
          this.tableTotal = parseInt(data.total)
        }
      },
      handleCurrentChange(page) {
        this.searchQuery.pageNum = page;
        this.getDeviceRegulationList();
      },
      handleSearch(){
        this.searchQuery.pageNum = 1;
        this.getDeviceRegulationList();
      },
      handleSelectCurrentChange(val) {
        this.fromData.ruleId = val?.id;
      }
		}
	}
</script>

